
export function hostedPaymentsRangeCheck(input, startValue, endValue) {
    /* eslint-disable prefer-destructuring */
    const length = startValue.toString().length;
    /* eslint-enable prefer-destructuring */
    const substring = input.substring(0, length);
    const intValue = parseInt(substring, 10);
    return (startValue <= intValue && intValue <= endValue);
}

export function hostedPaymentsPerformBinCheck(value) {
    // Check for Null / Empty case
    if (!value)
        return false;

    // Amex
    if (value.substring(0, 2) === '34' ||
        value.substring(0, 2) === '37')
        return true;

    // China UnionPay
    if (value.substring(0, 2) === '62')
        return true;

    // Diners Club Carte Blanche 300-305
    if (hostedPaymentsRangeCheck(value, 300, 305))
        return true;

    // Diners Club International 36
    if (value.substring(0, 2) === '36')
        return true;

    // Diners Club US & Canada 54, 55
    // if (value.substring(0, 2) === '54' ||
    //     value.substring(0, 2) === '55')
    //     return true;

    // Discover Card 6011, 622126-622925, 644-649, 65
    if (value.substring(0, 4) === '6011' ||
        value.substring(0, 2) === '65' ||
        hostedPaymentsRangeCheck(value, 622126, 622925) ||
        hostedPaymentsRangeCheck(value, 644, 649))
        return true;

    // InterPayment 636
    if (value.substring(0, 3) === '636')
        return true;

    // InstaPayment 637-639
    if (hostedPaymentsRangeCheck(value, 637, 639))
        return true;

    // JCB 3528-3589
    if (hostedPaymentsRangeCheck(value, 3528, 3589))
        return true;

    // Maestro 50, 56-58, 6
    if (value.substring(0, 2) === '50' ||
        value.substring(0, 1) === '6' ||
        hostedPaymentsRangeCheck(value, 56, 58))
        return true;

    // MasterCard 2221-2720, 51-55
    if (hostedPaymentsRangeCheck(value, 2221, 2720) ||
        hostedPaymentsRangeCheck(value, 51, 55))
        return true;

    // Visa 4
    if (value.substring(0, 1) === '4')
        return true;

    // UATP 1
    if (value.substring(0, 1) === '1')
        return true;

    // No matches found
    return false;
}

export function hostedPaymentsPerformLuhnCheck(value) {
    let nCheck = 0;
    let bEven = false;

    for (let n = value.length - 1; n >= 0; n -= 1) {
        const cDigit = value.charAt(n);
        let nDigit = parseInt(cDigit, 10);

        if (bEven) {
            nDigit *= 2;
            if (nDigit > 9) nDigit -= 9;
        }

        nCheck += nDigit;
        bEven = !bEven;
    }

    return (nCheck % 10) === 0;
}

export function checkInputForCardData(input) {
    // If the input is null return false
    if (!input) {
        return false;
    }

    // Add spaces around the digits to separate it from words
    let spacedInput = '';
    for (let i = 0; i < input.length; i += 1) {
        const character = input.charAt(i);
        if (character.match(/[a-z]/i)) {
            spacedInput += ` ${character} `;
        }
        else {
            spacedInput += character;
        }
    }

    // Perform Regex Pattern match to find groups of numbers
    const pattern = '\\b(?:\\d[ -]*?){13,16}\\b';
    const matchValue = spacedInput.match(pattern);

    // If there is no match, return false
    if (!matchValue) return false;

    // Strip any spaces or dashes out
    const potentialCard = matchValue.toString()
        .replace(/\s+/g, '')
        .replace(/-/g, '');

    // Perform the card checks
    if (hostedPaymentsPerformBinCheck(potentialCard)) {
        if (hostedPaymentsPerformLuhnCheck(potentialCard)) {
            return true;
        }
    }

    return false;
}